<template>
    <div class="alert alert-danger alert-dismissible fade show alert-has-error" role="alert">
        {{message}}
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        props: ['message']
    };
</script>
